import { render, staticRenderFns } from "./TiskHkSestava.vue?vue&type=template&id=4c84d54e&"
import script from "./TiskHkSestava.vue?vue&type=script&lang=js&"
export * from "./TiskHkSestava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports